:host {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  background: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}

.header__actions {
  display: flex;
}

.packages-content {
  flex-grow: 2;
  height: 100%;

  .packages-grid {
    height: 100%;
  }

  gz-grid-view {
    min-height: 100%;
    align-items: stretch;

    .action-button-text,
    .action-icon {
      vertical-align: middle;
    }

    .action-icon {
      display: inline-block;

      &:before {
        font-size: 32px;
      }
    }

    .action-button {
      margin-right: calc(1.5 * var(--spacer));
    }
  }
}
